import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const CameraFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="cameraFilled" ref={ref} {...props}>
      <path d="M12,11.46a1.68,1.68,0,1,1-1.68,1.68A1.68,1.68,0,0,1,12,11.46ZM20.75,9v8.76a2.84,2.84,0,0,1-2.84,2.84H6.09a2.84,2.84,0,0,1-2.84-2.84V9A2.84,2.84,0,0,1,6.09,6.16H7.45c.49,0,.68,0,.92-.62a2.27,2.27,0,0,1,2.29-1.6h2.71a2.27,2.27,0,0,1,2.29,1.61c.24.56.42.61.92.61h1.36A2.86,2.86,0,0,1,20.75,9ZM12,9.14a4,4,0,1,0,4,4A4,4,0,0,0,12,9.14Z" />
    </Icon>
  ),
) as IconWithRender;

CameraFilledIcon.displayName = 'CameraFilledIcon';
CameraFilledIcon.renderIcon = (props) => <CameraFilledIcon {...props} />;
export default CameraFilledIcon;
